// import logo from './logo.svg';
import './App.css';
import Navbar from './Components/Navbar';
import TextArea from './Components/TextArea';
// import About from './Components/About';
import React, { useState } from 'react';
import Alert from './Components/Alert';

 /* import {
   BrowserRouter as Router,
   Routes,
   Route,
   Link
 } from "react-router-dom"; */

function App() {
  const [mode, setMode] = useState('light');
  const [msg, setAlert] = useState(null);

  const showAlert= (message,type)=>{
    setAlert({
        message: message,
        type: type

      })
      setTimeout(()=>{
        setAlert(null);
      },1500);
   
  }
   

  const togglemode=()=>{
    if(mode==='light'){
      setMode('dark');
      document.body.style.backgroundColor='#151e3a';
      showAlert("Dark mode is Enabled","success");
      //document.title='Upshots - Dark Mode';
    }
    else{
      setMode('light');
      document.body.style.backgroundColor='white';
      showAlert("Light mode is Enabled","success");
      //document.title='Upshots';

      
    }
  }
  return (
  <>
  {/* <Router>  */}
  <Navbar title="Upshots" mode={mode} togglemode={togglemode}/>
  <Alert alert={msg} showAlert={showAlert}/>
  <div className="container my-3 ">
  {/* <Routes>
    <Route exact path="/about" element={<About/>} /> */}
    {/* <Route path="/" element={<TextArea heading="Try Upshots - Word counter, Character counter,Renove extra spaces" mode={mode} showAlert={showAlert} />} /> */}
  {/* </Routes> */}
  <TextArea heading="Try Upshots - Word counter, Character counter,Renove extra spaces" mode={mode} showAlert={showAlert} />
  </div>
  {/* </Router> */}
  
  </>
  );
}

export default App;
